module.exports = __webpack_public_path__ + "static/img/icon-step2-on.3cdbc00e.png";